import React, { useEffect, useState } from 'react';
import SystemDashboardTemplate from 'Components/templates/dashboard';
import { createSelector } from 'reselect';
import { DashboardSliceState } from 'slices/dashboard/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from 'slices/dashboard/thunk';
import { last } from 'lodash';

const selectProjects = createSelector(
  (state: any) => state.Dashboard,
  ({
    userCount,
    lastSync,
    isLoadingData
  }: DashboardSliceState) => ({
    userCount,
    lastSync,
    isLoadingData
  })
)

const Dashboard = () => {
  document.title = "Dashboards | IbexIQ";
  const dispatch: any = useDispatch();
  const { userCount, lastSync, isLoadingData } = useSelector(selectProjects)

  const initializePage = async () => {
    // If empty then get
    if (!userCount || !lastSync) {
      dispatch(getDashboardData());
    }
  }

  useEffect(() => {
    initializePage()
  }, [])

  const handleClick = () => {
    alert("Work in progress")
  }


  return <SystemDashboardTemplate
    userCount={userCount}
    lastSync={lastSync}
    isLoadingData={isLoadingData}
    handleClick={handleClick}
  />
}

export default Dashboard;